import { 
  trackCustomHeapEvent,
  initializeAnalytics,
} from '@tcc/analytics';
import { UserDetails, ActionProperties, HeapActionProperties } from './types';
import { determineUserId, determineEnv } from 'util/env';

export const initializeHeap = (userDetails: UserDetails) => {
  if (!window.heap) {
    initializeAnalytics({ userDetails });
  }
};

export const trackHeapAction = (eventName: string, properties: ActionProperties = {}) => {
  if (!window.heap) {
    return;
  }

  const heapDetails = {
    env: determineEnv(),
    userId: determineUserId(),
    app: 'script-creator',
  };

  const eventProperties: HeapActionProperties = {
    ...heapDetails,
    ...properties,
  };

  const { stop = 0, start = 0, items = 0 } = properties;

  if (stop || start) {
    eventProperties.seconds = (Number(stop) - Number(start)) / 1000;
    if (items) {
      eventProperties.avgSecondsPerItem = eventProperties.seconds / items;
    }
  }

  trackCustomHeapEvent(eventName, eventProperties);
};
